module.exports = __webpack_public_path__ + "kudos_2.svg?3a1a56a8360240ce8562fc2feb4639f8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_2.svg
// module id = 117
// module chunks = 0